export default __webpack_public_path__ + "static/media/gallery_04.3548e88b.jpg";